<template>
  <div v-if="show" class="lds-spinner">
    <div style="position: absolute;top: 100px;right: 100px;color:#FFF;font-size:20px;cursor: pointer;"><i class="el-icon-close" @click="closeLoading()"></i></div>
    <div class="spinner" style="width:250px;text-align:center;color:#FFF">
        <!-- <div><i class="el-icon-loading" style="font-size:16px"></i></div> -->
        <div>
          <img src="@/assets/images/qw_loading.gif" style="width:50px" alt="">
        </div>
        <!-- <div style="margin-top:10px;font-size:14px"><span>处理中&nbsp;({{time}}s)&nbsp;...</span></div> -->
        <div style="margin-top:25px;font-size:13px" v-if="code!=3"><span>正在处理，请稍候 ...&nbsp;({{time}}s)&nbsp;</span></div>
        <div style="margin-top:25px;font-size:13px" v-else><span>{{msg}}</span></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  data() {
    return {
        show:false,
        time:1,
        msg:"",
        code:'',
        resolve: '',
        reject: '',
    }
  },
  created(){

  },
  methods: {
    closeLoading:function(){
        this.show=false
        this.resolve()
    },
    close:function(){
       return new Promise((resolve, reject) => {
           this.resolve = resolve;
           this.reject = reject;
       });
    },
  },
}
</script>
<style scoped>
.lds-spinner{
  position: fixed;
  top:0;
  left:0;
  background:rgba(0,0,0,0.7);
  width:100%;
  height:100%;
  z-index:99999
}
.spinner {
  width: 25px;
  height: 25px;
  position:absolute;
  z-index: 999999;
  top:50%;
  left:50%;
  transform: translate(-50%);
  .double-bounce1, .double-bounce2 {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #FF000F;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-animation: bounce 2.0s infinite ease-in-out;
    animation: bounce 2.0s infinite ease-in-out;
  }
  .double-bounce2 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
  }
}
 
@-webkit-keyframes bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}
 
@keyframes bounce {
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AuditAsyn/index.vue